module.exports = __webpack_public_path__ + "static/media/zig-zag.8f1da753.mp3";